import { render, staticRenderFns } from "./EmailAndAccountField.vue?vue&type=template&id=3388439a&scoped=true"
import script from "./EmailAndAccountField.vue?vue&type=script&lang=ts"
export * from "./EmailAndAccountField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3388439a",
  null
  
)

export default component.exports